import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl =
  process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:5000";

// ================= FETCH USERS =================
export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async (
    { postcode = "", subcategory = "" } = {},
    { rejectWithValue, getState }
  ) => {
    try {
      const state = getState();

      // ================= SAFE VALUES =================
      const effectivePostcode =
        postcode?.trim() ||
        state?.businessUserSearch?.postcode?.trim() ||
        "";

      const effectiveSubcategory = subcategory?.trim() || "";

      if (!effectivePostcode) {
        return rejectWithValue("Postal code missing");
      }

      // ================= QUERY PARAMS =================
      const params = {
        postalCode: effectivePostcode,
      };

      if (effectiveSubcategory) {
        params.subcategory = effectiveSubcategory;
      }

      // ================= API CALL =================
      const res = await axios.get(
        `${baseUrl}/business/dashboard-filtered-details`,
        { params }
      );

      const data = res?.data;

      // ================= NORMALIZE RESPONSE =================
      let users = [];

      if (Array.isArray(data)) {
        users = data.flatMap((group) => group?.users || []);
      } else if (data?.users) {
        users = data.users;
      }

      return {
        users,
        count: data?.count || users.length,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// ================= SLICE =================
const usersSlice = createSlice({
  name: "users",
  initialState: {
    users: [],     // ✅ FIXED (was data)
    count: 0,
    loading: false,
    error: null,
    shouldRefresh: false,
  },

  reducers: {
    resetShouldRefresh: (state) => {
      state.shouldRefresh = false;
    },

    clearData: (state) => {
      state.users = [];
      state.count = 0;
      state.error = null;
      state.loading = false;
      state.shouldRefresh = false;
    },
  },

  extraReducers: (builder) => {
    builder
      // ================= LOADING =================
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      // ================= SUCCESS =================
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload?.users || [];
        state.count = action.payload?.count || 0;
      })

      // ================= ERROR =================
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { resetShouldRefresh, clearData } = usersSlice.actions;
export default usersSlice.reducer;